export const buttonWrapper = () => ({
    marginLeft: 16,
});
